import React from 'react';
import PropTypes from 'prop-types';

export const SDKWizardStepProgress = React.memo(({ status }) => {
  if (status === 'selected') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="193" height="3" viewBox="0 0 193 3" fill="none">
        <line x1="0.0585937" y1="1.27148" x2="192.059" y2="1.27148" stroke="url(#paint0_linear_857_15772)" strokeWidth="2" />
        <defs>
          <linearGradient id="paint0_linear_857_15772" x1="192.059" y1="2.27148" x2="0.0585938" y2="2.27148" gradientUnits="userSpaceOnUse">
            <stop offset="0.210938" stopColor="#0078D4" />
            <stop offset="0.783854" stopColor="#107C10" />
          </linearGradient>
        </defs>
      </svg>
    );
  } else if (status === 'default') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="193" height="3" viewBox="0 0 193 3" fill="none">
        <line x1="0.0585937" y1="1.03516" x2="192.059" y2="1.03516" stroke="#C8C6C4" strokeWidth="2" />
      </svg>
    );
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="193" height="3" viewBox="0 0 193 3" fill="none">
      <line x1="0.0585937" y1="1.03516" x2="192.059" y2="1.03516" stroke="#107C10" strokeWidth="2" />
    </svg>
  );
});

SDKWizardStepProgress.propTypes = {
  status: PropTypes.oneOf(['selected', 'behind', 'default']).isRequired,
};
